export default {
  FETCH_ALL: 'APPS/FETCH_ALL',
  SET_ALL: 'APPS/SET_ALL',
}
